import axios from 'axios';
import * as $api from '../../api/index.js';
export default {
  name: "dashboard",
  data() {
    return {
      content:'',
      baseUrl:'https://ctjdwx.cdqingyang.gov.cn/',
      name: window.sessionStorage.getItem('ms_username'),
      userInfo: JSON.parse(window.sessionStorage.getItem("user_info")),
      geoList: JSON.parse(window.sessionStorage.getItem('geolist')),
      userList: JSON.parse(window.sessionStorage.getItem('user_list')),
      activeName: 'first',
      infoVisible:false,
      radio1: 3,
      radio2: 2,
      radio3: 3,
      left_height: 0,
      tabs_height: 0,
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 7
      },
      newsInfo:{
        title:'',
        field:[]
      },
      totalStatic:{
        courtyardCount:0,
        householdsCount:0,
        floorCount:0,
        userCount:0
      },
      pageTotal: 20,
      dataList: []
    };
  },
  components: {},
  created() {
    let scrollArray = [];
    this.getNotice('通知表单',scrollArray);
    this.dataList = scrollArray;
    this.getStaticData();
  },
  computed: {
    role() {
      return this.name === "admin" ? "超级管理员" : "普通用户";
    }

  },
  mounted() {
    this.getBudgetLine();
    this.getCostConfiscateData();
    this.getfeedBackBar();
    this.getHeight();
  },
  methods: {
    /**
     * 统计总数
     */
    getStaticData() {
      let that = this;
      return new Promise((resolve, reject) => {
        $api.totalStatic(that.userInfo[0].roleName,that.userInfo[0].organName,'房屋统计').then(res => {
            console.log('xxxxxxxxxxxx',res);
            if(res.data) {
                that.totalStatic.courtyardCount = res.data.zongdongshu;
                that.totalStatic.householdsCount = res.data.zonghushu;
                that.totalStatic.floorCount = res.data.zongyuanluo;
                that.totalStatic.userCount = res.data.zongjuzhurenshu;
            }
        }).catch(error => {
          reject(error)
        });
      })
    },
    /**
     * 院落预算统计图
     */
    getBudgetLine(){
      let that = this;
      return new Promise((resolve, reject) => {
        $api.getIncome(that.userInfo[0].organName,'院落预算','费用分析').then(res => {
          that.drawLine(res.data);
        }).catch(error => {
          reject(error)
        });
      })
    },
    /**
     * 费用收缴饼图
     */
    getCostConfiscateData(){
      let that = this;
      return new Promise((resolve, reject) => {
        $api.getIncome(that.userInfo[0].organName,'费用收缴','费用分析').then(res => {
          that.drawPie(res.data);
        }).catch(error => {
          reject(error)
        });
      })
    },
    /**
     * 问题反馈统计图
     */
    getfeedBackBar(){
      let that = this;
      return new Promise((resolve, reject) => {
        $api.getIncome(that.userInfo[0].organName,'问题反馈','院落分析').then(res => {
          that.drawBar(res.data);
        }).catch(error => {
          reject(error)
        });
      })
    },
    /**
     * 院落预算折线图配置
     * @param {Object} data
     */
    drawLine(data) {
      let legendData = [data[0].yardName];
      let xAxisData = [];
      let yAxisData = [];
      data.forEach((item, index)=>{
        xAxisData.push(item.classMont + item.classPeriod)
        yAxisData.push(item.classCount)
      })
      let myChart = this.$echarts.init(document.getElementById("line"));
      // 绘制图表
      myChart.setOption({
        backgroundColor: '#FFF',
        grid: {
          top: '10%',
          bottom: '15%',
          left: '10%',
          right: '4%',
        },
        tooltip: {
          trigger: 'axis',
          label: {
            show: true,
          },
          formatter: function(prams) {
          	return prams[0].seriesName +" : "+ prams[0].data + " 元"
          }
        },
        legend: {
          show: false,
          icon: 'circle',
          align: 'left',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 20,
          borderRadius: 4,
          textStyle: {
            fontSize: 14,
          },
          x: 'center',
          y: 'bottom',
          data: legendData,
        },
        xAxis: {
          boundaryGap: true, //默认，坐标轴留白策略
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          data: xAxisData,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(33,148,246,0.2)',
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [{
            name: legendData[0],
            type: 'line',
            symbol: 'circle',
            symbolSize: 7,
            lineStyle: {
              color: '#52C1F5',
              shadowBlur: 12,
              shadowColor: 'rgb(33,148,246,0.9)',
              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
            itemStyle: {
              color: '#52C1F5',
              borderWidth: 1,
              borderColor: '#FFF',
            },
            data: yAxisData
          }
        ]
      });
    },
    /**
     * 费用收缴饼图
     * @param {Object} data
     */
    drawPie(data) {
      let legendData = [data[0].yardName];
      let echartData = [];
      data.forEach((item, index)=>{
        let echartItem = {};
        echartItem.name = item.classType;
        echartItem.value = item.classCount;
        echartData.push(echartItem)
      })
      let bgColor = '#fff';
      let title = '总数';
      let color = ['#FDB33A', '#ED5152', '#708DF5', '#B068FB', '#03DCAA', '#4AEAB0'];

      let formatNumber = function(num) {
        let reg = /(?=(\B)(\d{3})+$)/g;
        return num.toString().replace(reg, ',');
      }
      let total = echartData.reduce((a, b) => {
        return a + b.value * 1
      }, 0);
      let myChart = this.$echarts.init(document.getElementById("pie"));
      myChart.setOption({
        backgroundColor: bgColor,
        color: color,
        // tooltip: {
        //     trigger: 'item'
        // },
        title: [{
          text: '{name|' + title + '}\n{val|' + formatNumber(total) + '}',
          top: 'center',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: this.transformFontSize(20),
                fontWeight: 'normal',
                color: '#666666',
                padding: [10, 0]
              },
              val: {
                fontSize: this.transformFontSize(20),
                fontWeight: 'bold',
                color: '#333333',
              }
            }
          }
        }, {
          text: '单位：元',
          top: 20,
          left: 20,
          textStyle: {
            fontSize: 14,
            color: '#666666',
            fontWeight: 400
          }
        }],
        legend: {
          orient: 'vertical',
          icon: 'rect',
          x: '80%',
          y: 'center',
          itemWidth: 12,
          itemHeight: 12,
          align: 'left',
          textStyle: {
            rich: {
              name: {
                fontSize: 12
              },
              value: {
                fontSize: 16,
                padding: [0, 5, 0, 15]
              },
              unit: {
                fontSize: 12
              }
            }
          },
          formatter: function(name) {
            let res = echartData.filter(v => v.name === name);
            res = res[0] || {};
            let unit = res.unit || '';
            return '{name|' + name + '}'
          }
          // data: legendName
        },
        series: [{
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '50%'],
          data: echartData,
          hoverAnimation: false,
          itemStyle: {
            normal: {
              borderColor: bgColor,
              borderWidth: 2
            }
          },
          labelLine: {
            normal: {
              length: 15,
              length2: 80,
              lineStyle: {
                color: '#e6e6e6'
              }
            }
          },
          label: {
            normal: {
              formatter: params => {
                return (
                  '{icon|●}{name|' + params.name + '}{value|' +
                  formatNumber(params.value) + '}'
                  // + ' ' + params.percent + '%'
                );
              },
              padding: [0, -100, 25, -100],
              rich: {
                icon: {
                  fontSize: 20
                },
                name: {
                  fontSize: 14,
                  padding: [0, 10, 0, 4],
                  color: '#666666'
                },
                value: {
                  fontSize: this.transformFontSize(14),
                  fontWeight: 'bold',
                  color: '#333333'
                }
              }
            }
          },
        }]
      });
    },
    /**
     * 问题反馈柱状图
     * @param {Object} data
     */
    drawBar(data) {
      let legendData = [data[0].yardName];
      let unit = [data[0].calssUnit];
      let xAxisData = [];
      let yAxisData = [];
      data.forEach((item, index)=>{
        xAxisData.push(item.classMont + item.classPeriod)
        yAxisData.push(item.classCount)
      })
      let myChart = this.$echarts.init(document.getElementById("bar"));
      myChart.setOption({
        title: {
          text: '',
        },
        grid: {
          top: "10%",
          left: "5%",
          right: "0%",
          bottom: "15%"
        },
        tooltip: {
        	trigger: 'axis',
        	axisPointer: {
        		type: 'line',
        		lineStyle: {
        			opacity: 0
        		}
        	},
        	formatter: function(prams) {
        		return "反馈数：" + prams[0].data + unit
        	}
        },
        legend: {},
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#EEEEEE',
            },
          },
          axisLabel: {
            color: '#949494',
          },
          data: xAxisData
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(33,148,246,0.2)',
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          }
        },
        series: [{
          type: 'bar',
          barWidth: '5%',
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 40,
              color: '#778BFE',
            },
          },
          data: yAxisData
        }]
      })
    },
    handleClick(tab, event) {
      let that = this;
      let classType = '';
      let scrollArray = [];
      if(tab.label == '通知'){
        classType = '通知表单'
      }else if(tab.label == '公告'){
        classType = '普通公告表单'
        that.getNotice('重要公告表单',scrollArray);
      }
      that.getNotice(classType,scrollArray);
      that.dataList = scrollArray;
    },
    /**
     * 获取通知公告
     * @param {Object} classType 类型
     */
    getNotice(classType,scrollArray){
      let that = this;
    //   console.log('tongzhi');
      // let scrollArray = [];
      $api.getNoticeScrollList(classType,that.userInfo[0].organName,that.userList[0].yardGuid).then(res => {
        if(res.data.length >= 0){
        	for(var i=0;i<res.data.length;i++){
        		let scrollItem = {};
        		scrollItem.roleName = res.data[i].roleName;
        		scrollItem.newsId = res.data[i].indexNo;
        		scrollItem.title = res.data[i].smsgName;
        		scrollItem.from = res.data[i].organName;
        		scrollArray.push(scrollItem)
        	}
        }
        // that.dataList = scrollArray;
      }).catch(error => {
        console.log(error)
      });
    //   console.log('scrollArray', scrollArray);
    },
    // 根据不同的屏幕宽度换算字体大小
    transformFontSize(fontsize) {
      // 获取屏幕宽度
      const width = window.screen.width
      const ratio = width / 1920
      // 取下整
      return parseInt(fontsize * ratio)
    },
    getHeight() {
      this.left_height = this.$refs.left_content.offsetHeight + 'px';
      this.tabs_height = this.$refs.left_content.offsetHeight - 150 + 'px';
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val);
      // this.getData();
    },
    //公告详情页面
    contentInfo(indexNo) {
      let that = this;
    	that.infoVisible = true;
      $api.getNoticeInfo(indexNo).then(res => {
        $api.getNoticeContent(res.data.smsgName).then(res1 =>{
          that.newsInfo.title = res.data.smsgName;
          that.newsInfo.field = res1.data;
          console.log(that.newsInfo.field)
        }).catch(err =>{

        })
      }).catch(error => {
        console.log(error)
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js